import React, { useEffect } from 'react';
import { OptInProvider } from './components/OptInContext';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { PrizeGallery } from './components/PrizeGallery';
import { HowItWorks } from './components/HowItWorks';
import { LocationHours } from './components/LocationHours';
import { Footer } from './components/Footer';
export function App() {
  // Force the cosmic dark theme regardless of system preference
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);
  return <OptInProvider data-id="element-0">
      <div className="cosmic-bg relative min-h-screen w-full overflow-x-hidden text-white" data-id="element-1">
        <Nav data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <PrizeGallery data-id="element-5" />
          <HowItWorks data-id="element-6" />
          <LocationHours data-id="element-7" />
        </main>
        <Footer data-id="element-8" />
      </div>
    </OptInProvider>;
}